<div class="ai-viewer">
  <div class="ai-viewer__bar" *ngIf="source">
    <span class="ai-viewer__name" [title]="source.fileName">
      <i class="ri-file-text-line me-1"></i>{{ source.fileName }}
    </span>

    <div class="ai-viewer__tools" *ngIf="isPdf && pageCount > 0">
      <button type="button" class="btn btn-sm btn-light" (click)="previous()"
        [disabled]="currentPage <= 1" [attr.aria-label]="'ai-extraction.viewer.previous' | translate">
        <i class="ri-arrow-left-s-line"></i>
      </button>
      <span class="ai-viewer__page">{{ currentPage }} / {{ pageCount }}</span>
      <button type="button" class="btn btn-sm btn-light" (click)="next()"
        [disabled]="currentPage >= pageCount" [attr.aria-label]="'ai-extraction.viewer.next' | translate">
        <i class="ri-arrow-right-s-line"></i>
      </button>
      <button type="button" class="btn btn-sm btn-light ms-2" (click)="zoomBy(-0.2)"
        [attr.aria-label]="'ai-extraction.viewer.zoom-out' | translate">
        <i class="ri-zoom-out-line"></i>
      </button>
      <button type="button" class="btn btn-sm btn-light" (click)="zoomBy(0.2)"
        [attr.aria-label]="'ai-extraction.viewer.zoom-in' | translate">
        <i class="ri-zoom-in-line"></i>
      </button>
    </div>
  </div>

  <div class="ai-viewer__stage" #stage>
    <div class="ai-viewer__empty" *ngIf="!source && !loading">
      <i class="ri-cursor-line"></i>
      <p>{{ 'ai-extraction.viewer.empty' | translate }}</p>
    </div>

    <div class="ai-viewer__empty" *ngIf="loading">
      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      <p>{{ 'ai-extraction.viewer.loading' | translate }}</p>
    </div>

    <div class="ai-viewer__empty" *ngIf="failed && !loading">
      <i class="ri-error-warning-line"></i>
      <p>{{ 'ai-extraction.viewer.failed' | translate }}</p>
    </div>

    <div class="ai-viewer__page-wrap" *ngIf="source && isPdf && !failed && !loading"
      [style.width.px]="viewportWidth" [style.height.px]="viewportHeight">
      <canvas #canvas></canvas>
      <div class="ai-viewer__highlight" *ngFor="let box of highlights"
        [style.left.px]="box.left" [style.top.px]="box.top"
        [style.width.px]="box.width" [style.height.px]="box.height"></div>
    </div>

    <img class="ai-viewer__image" *ngIf="source && !isPdf && imageUrl && !failed && !loading"
      [src]="imageUrl" [alt]="source.fileName" />
  </div>

  <div class="ai-viewer__snippet" *ngIf="source && snippet" aria-live="polite">
    <div class="ai-viewer__snippet-label">
      <i class="ri-double-quotes-l me-1"></i>{{ 'ai-extraction.viewer.snippet' | translate }}
      <span class="badge badge-soft-success ms-2" *ngIf="highlighted">
        {{ 'ai-extraction.viewer.located' | translate }}
      </span>
      <span class="badge badge-soft-secondary ms-2" *ngIf="!highlighted && !rendering">
        {{ 'ai-extraction.viewer.not-located' | translate }}
      </span>
    </div>
    <blockquote>{{ snippet }}</blockquote>
  </div>
</div>
